<template>
  <div id="coachInfo">
    <el-card
      class="mainCard clear-card coachInfoCard"
      shadow="hover"
      :body-style="{padding: '20px 20px 20px 30px'}"
    >
      <div
        v-if="$mq === 'mobile' || $mq === 'tablet'"
      >
        <div class="title defaultCursor">
          {{ $t('leader.coach.myCoach') }}
        </div>

        <el-row
          class="layout layoutMobile"
          :class="`${$mq}Mode`"
          :gutter="12"
        >
          <el-col
            class="left"
            :span="colResponse.one"
          >
            <el-image
              :src="coach.profile_image"
              style="width: 100px; height: 100px; border-radius: 50%;"
              fit="cover"
            >
              <div
                slot="placeholder"
                v-loading="true"
                class="image-slot"
                style="width: 100px; height: 100px; border-radius: 50%;"
              >
                <br />
              </div>
              <div
                slot="error"
                class="image-slot imageAlt"
                style="width: 100px; height: 100px; border-radius: 50%;"
              >
                <img
                  src="@/assets/coach_avatar/default_profile.jpg"
                  alt="profile"
                  class="defaultProfile"
                />
                <!--<i class="el-icon-picture-outline"></i>-->
              </div>
            </el-image>
          </el-col>

          <el-col
            class="right"
            :span="colResponse.two"
          >
            <div class="name defaultCursor">
              {{ coach.first_name }} {{ coach.last_name }}
            </div>

            <div class="email">
              <a
                :href="`mailto:${coach.email}`"
                target="_blank"
                class="emailLink"
              >
                {{ coach.email }}
              </a>
              <el-button
                size="small"
                type="text"
                class="copyLinkBtn"
                @click="copyLink(coach.email)"
              >
                <i class="el-icon-copy-document"></i>
              </el-button>
            </div>

            <div>
              <el-button
                round
                type="primary"
                @click="$router.push({name: 'schedule'})"
              >
                {{ $t('leader.coach.scheduleMeeting') }}
              </el-button>
            </div>
          </el-col>
        </el-row>
      </div>

      <div
        v-else
        class="layout"
      >
        <div class="col1 defaultCursor">
          {{ $t('leader.coach.myCoach') }}
        </div>

        <div class="col2">
          <el-image
            :src="coach.profile_image"
            style="width: 100px; height: 100px; border-radius: 50%;"
            fit="cover"
          >
            <div
              slot="placeholder"
              v-loading="true"
              class="image-slot"
              style="width: 100px; height: 100px; border-radius: 50%;"
            >
              <br />
            </div>
            <div
              slot="error"
              class="image-slot imageAlt"
              style="width: 100px; height: 100px; border-radius: 50%;"
            >
              <img
                src="@/assets/coach_avatar/default_profile.jpg"
                alt="profile"
                class="defaultProfile"
              />
              <!--<i class="el-icon-picture-outline"></i>-->
            </div>
          </el-image>
        </div>

        <div class="col3">
          <div class="name defaultCursor">
            {{ coach.first_name }} {{ coach.last_name }}
          </div>

          <div class="email">
            <a
              :href="`mailto:${coach.email}`"
              target="_blank"
              class="emailLink"
            >
              {{ coach.email }}
            </a>
            <el-button
              size="small"
              type="text"
              class="copyLinkBtn"
              @click="copyLink(coach.email)"
            >
              <i class="el-icon-copy-document"></i>
            </el-button>
          </div>

          <div
            v-if="!nonAcFlag"
            class="profile"
          >
            <el-button
              type="text"
              class="profileLink"
              @click="openProfile"
            >
              {{ $t('leader.coach.viewFullProfile') }}
            </el-button>
          </div>
        </div>

        <div class="col4">
          <el-button
            round
            type="primary"
            @click="$router.push({name: 'schedule'})"
          >
            {{ $t('leader.coach.scheduleMeeting') }}
          </el-button>
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  computed: {
    ...mapState({
      coach: (state) => state.myCoach.coach,
    }),
    colResponse() {
      const col = {};
      if (this.$mq === 'mobile') {
        col.one = 24;
        col.two = 24;
      } else {
        col.one = 8;
        col.two = 16;
      }
      return col;
    },

    nonAcFlag() {
      let flag = false;
      if (this.coach && !this.coach.is_ac) {
        flag = true;
      }
      return flag;
    },
  },

  methods: {
    openProfile() {
      window.open(this.coach.profile_url, '_blank');
    },

    copyLink(link) {
      try {
        this.$copyText(link);
        this.$message.success(this.$t('common.copied'));
      } catch (err) {
        console.log(err);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
#coachInfo {
  .coachInfoCard {
    margin-bottom: 15px;

    .title {
      font-weight: bold;
      margin-bottom: 10px;
    }

    .layoutMobile {
      display: block;
      width: 100%;

      .name {
        margin-bottom: 10px;
      }

      .email {
        margin-bottom: 10px;
      }

      &.mobileMode {
        text-align: center;
        flex-wrap: wrap;

        .left {
          align-items: center;
          margin-bottom: 15px;
        }
      }
    }

    .layout {
      display: flex;
      text-align: left;

      & > div {
        display: flex;
        flex-direction: column;
        justify-content: center;
      }

      .col1 {
        width: 15%;
        font-weight: bold;
        line-height: 30px;
      }

      .col2 {
        width: 20%;
        text-align: center;

        & > .el-image {
          margin: 0 auto;
        }
      }

      .col3 {
        width: 35%;
      }

      .col4 {
        text-align: right;
      }

      .name {
        font-weight: bold;
      }

      .email {
        font-style: italic;
        padding-top: 3px;
        padding-bottom: 3px;

        .emailLink {
          color: var(--themeFontColor);
          word-break: break-word;

          &:not(:hover) {
            text-decoration: none;
          }
        }

        .copyLinkBtn {
          padding: 2px 5px;
          color: var(--themeFontColor);
        }
      }

      .profileLink {
        color: var(--themeFontColor);
        padding-top: 3px;
        padding-bottom: 3px;
        text-decoration: underline;
      }

      &.scheduleNextMeeting {
        margin-top: 10px;
      }
    }

    .imageAlt {
      width: 100%;
      height: 100%;
      background: rgba(0, 0, 0, 0.3);

      i {
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 35px;
        opacity: 0.7;
      }

      .defaultProfile {
        width: 100%;
        height: 100%;
      }
    }
  }
}
</style>
